module.exports = __webpack_public_path__ + "static/service-banner-ratio-ec577caefddf6cad9610bfc85b7dd190.jpeg";